export function ProfileMatchingSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/profile-matching.svg'"></ng-include>`
    }
}
            